import { Group } from "@mantine/core"
import { AgencyOperationsAdminTalentTabs } from "src/components/agency/operations/administrator/talent/AgencyOperationsAdminTalentTabs"
import { EditAgencyOperationsAdminTalentAction } from "src/components/agency/operations/administrator/talent/AgencyOperationsAdminTalentActions"
import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { useAppState } from "src/state"
import { AgencyOperationsAdminTalentView } from "src/components/agency/operations/administrator/talent/AgencyOperationsAdminTalentView"

export function AgencyOperationsAdminTalent() {

    const { currentItem } = useAppState(state=>state.users)

    return (
        <PageLayout
            header={
                <PageHeader
                    title={`${currentItem?.id}`}
                    renderAction={
                        <Group gap="sm">
                            <EditAgencyOperationsAdminTalentAction />
                        </Group>
                    }
                />
            }
        >
            <AgencyOperationsAdminTalentTabs/>
            <AgencyOperationsAdminTalentView/>
        </PageLayout>
    )

}